import {useState, useEffect} from 'react';

export function useUserData() {
  const [state, setState] = useState(null)

  useEffect(() => {
    const uag = window.HANDELSBLATT_UAG || {};

    if (uag.userFirstName && uag.userLastName) {
      const firstName = decodeURIComponent(uag.userFirstName);
      const lastName = decodeURIComponent(uag.userLastName);

      setState({
        displayName: `${firstName} ${lastName}`,
        initials: `${firstName[0].toUpperCase()}${lastName[0].toUpperCase()}`
      });
    }
    else if (uag.userEmail) {
      const email = decodeURIComponent(uag.userEmail);

      setState({
        displayName: email,
        initials: email[0].toUpperCase()
      })
    }
  }, []);

  return state;
};
